class ReqService {
  isAlreadySended = false;
  socket = null;
  lastReq = null;
  isFirstReq = true;
  setLastReq(req) {
    this.lastReq = req;
  }
  setSocket(socket) {
    this.socket = socket;
  }
  sendReq() {
    if (this.isAlreadySended) return;
    this.isAlreadySended = true;
    if (this.socket && this.lastReq) {
      this.socket.send(this.lastReq);
    }
  }
  setIsFirstReqToFalse() {
    this.isFirstReq = false;
  }
  resetAll() {
    this.isAlreadySended = false;
    this.socket = null;
    this.lastReq = null;
    this.isFirstReq = true;
  }
}

export const reqServiceSingleton = new ReqService();
